export const footer = {
  "description": "La plataforma de intercambio de alojamientos entre propietarios de Airbnb. Viaja gratis por todo el mundo.",
  "company": "Empresa",
  "about": "Acerca de",
  "howItWorks": "Cómo funciona",
  "blog": "Blog",
  "careers": "Carreras",
  "support": "Soporte",
  "help": "Centro de ayuda",
  "contact": "Contacto",
  "terms": "Condiciones de uso",
  "privacy": "Privacidad",
  "community": "Comunidad",
  "members": "Miembros",
  "destinations": "Destinos",
  "events": "Eventos",
  "newsletter": "Boletín",
  "newsletterText": "Recibe nuestras últimas ofertas y noticias",
  "emailPlaceholder": "Tu correo electrónico",
  "newsletterSuccess": "¡Inscripción exitosa!",
  "newsletterError": "Ha ocurrido un error.",
  "newsletterInvalid": "Correo electrónico inválido.",
  "subscribe": "Suscribirse",
  "rights": "Todos los derechos reservados",
  "madeWith": "Hecho con",
  "by": "por el equipo de DONKEY TRAVEL"
};
